export default __webpack_public_path__ + "static/not-found-bg-mobile-5c6bf438f4c8fba88fbb0b06fd1983ba.png";